export const TYPES = {
  INPUT: 'input',
  IMAGE: 'image',
};
